import Router from "vue-router";
import {PublicAreaComponent} from "./components/views/publicArea/publicArea";
import {AdminAreaComponent} from "./components/views/adminArea/adminArea";
import {HomeComponent} from "./components/views/home/home";
import {LandingComponent} from "./components/views/landing/landing";
import {AdminHomeComponent} from "./components/views/adminHome/adminHome";
import {NoAuthComponent} from "./components/views/noAuth/noAuth";


import {AutomationsViewComponent} from "./components/views/automationsView/automationsView";
import {AutomationDetailViewComponent} from "./components/views/automationDetailView/automationDetailView";
import {UsersViewComponent} from "./components/views/usersView/usersView";
import {UserViewComponent} from "./components/views/userDetailView/userDetailView";
import {InstallersViewComponent} from "./components/views/installersView/installersView";
import {InstallerViewComponent} from "./components/views/installerDetailView/installerDetailView";

export const Routes = {
  privateArea: { name: "privateArea", path: "/"},
  adminHome: { name: "adminHomeRoute", path: "/home"},
  noAuth: { name: "noAuthRoute", path: "/noAuth"},
  // publicArea: { name: "publicArea", path: "/"},
  // home: { name: "homeRoute", path: "/home"},
  login: { name: "loginRoute", path: "/login" },
  automations: { name: "automationsRoute", path: "/automations"  },
  automationDetail: { name: "automationDetailRoute", path: "/automations/:id"  },
  users: { name: "usersRoute", path: "/users"  },
  userDetail: { name: "userDetailRoute", path: "/users/:id"  },
  installers: { name: "installersRoute", path: "/installers"  },
  installerDetail: { name: "installerDetailRoute", path: "/installers/detail"  }
};

const routes = [
  { path: "*", component: LandingComponent },
  {
    path: Routes.noAuth.path,
    name: Routes.noAuth.name,
    component: NoAuthComponent,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: Routes.login.path,
    name: Routes.login.name,
    component: LandingComponent,
    meta: {
      requiresAuth: false,
      roles: ["Standard"]
    }
  },
  {
    path: Routes.privateArea.path,
    name: Routes.privateArea.name,
    component: AdminAreaComponent,
    meta: {
      requiresAuth: true,
      roles: ["Admin"]
    },
    children: [
      {
        path: Routes.adminHome.path,
        name: Routes.adminHome.name,
        component: AdminHomeComponent,
        meta: {
          requiresAuth: true,
          title: "NoAuthComponent",
          roles: ["Admin"]
        }
      },
      {
        path: Routes.automations.path,
        name: Routes.automations.name,
        component: AutomationsViewComponent,
        meta: { requiresAuth: true, title: "automationsRequests" }
      },
      {
        path: Routes.automationDetail.path,
        name: Routes.automationDetail.name,
        component: AutomationDetailViewComponent,
        meta: { requiresAuth: true }
      },
      {
        path: Routes.users.path,
        name: Routes.users.name,
        component: UsersViewComponent,
        meta: { requiresAuth: true, title: "usersRequests" }
      },
      {
        path: Routes.userDetail.path,
        name: Routes.userDetail.name,
        component: UserViewComponent,
        meta: { requiresAuth: true }
      },
      {
        path: Routes.installers.path,
        name: Routes.installers.name,
        component: InstallersViewComponent,
        meta: { requiresAuth: true, title: "installersRequests" }
      },
      {
        path: Routes.installerDetail.path,
        name: Routes.installerDetail.name,
        component: InstallerViewComponent,
        meta: { requiresAuth: true }
      }
    ]
  }
];

export class RouterManager {

  router: Router;

  static instance: RouterManager;

  constructor() {
    this.router = new Router({
      mode: "history",
      routes: routes,
    });
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/router.ts